class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-notification').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.itemsContainer = document.getElementById('main-cart-items-notification');
    if (this.itemsContainer) {
      this.itemsContainer.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    // this.addEventListener('change', this.debouncedOnChange.bind(this));

    this.html = document.documentElement;
    this.notificationWrapper = document.getElementById('cart-notification-wrapper');
    this.notification = document.getElementById('cart-notification');
    this.mobileAddCartButton = document.getElementById('mobile-add-cart-button');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.html.classList.add('no-scroll');
    this.notificationWrapper.classList.add('active');
    this.notification.classList.add('animate', 'active');
    this.mobileAddCartButton.classList.add('hidden');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.html.classList.remove('no-scroll');
    this.notificationWrapper.classList.remove('active');
    this.notification.classList.remove('active');
    this.mobileAddCartButton.classList.remove('hidden');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      this.header?.reveal();
      this.open();
  }

  renderUpsellContents(parsedState) {
    document.getElementById(section.id).innerHTML =
    this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
}

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      // {
      //   id: 'cart-notification-product',
      //   selector: `#cart-notification-product-${this.productId}`,
      // },
      {
        id: 'main-cart-items-notification',
        section: document.getElementById('main-cart-items-notification').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-notification-progress',
        section: 'cart-notification-progress',
        selector: '#cart-notification-progress-inner',
      },
      {
        id: 'cart-notification-upsells',
        section: 'cart-notification-upsells',
        selector: '#cart-upsell-row-container'
      },
      {
        id: 'cart-notification-checkout-button',
        section: 'cart-notification-checkout-button',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
      this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);
        document.getElementById('cart-extra-products')?.classList.toggle('hide-extra-products', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        document.getElementById(`CartItem-${line}`)?.querySelector(`[name="${name}"]`)?.focus();
        this.disableLoading();
      }).catch((error) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        console.log(window.cartStrings.error);
        console.error('Cart update error:', error);
        this.disableLoading();
      });
  }

  updateUpsellCartSections(line, quantity) {
    // Get the cart-notification element
    const cartNotification = document.querySelector('cart-notification');
    if (!cartNotification) return;

    // Prepare the sections to update
    const sectionsToRender = cartNotification.getSectionsToRender();
    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToRender.map((section) => section.section),
      sections_url: window.location.pathname
    });

    // Use fetchConfig() if you have it, or expand inline:
    fetch(`${routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        // Update all relevant sections
        sectionsToRender.forEach((section) => {
          // Defensive: skip if selector/section missing
          if (!parsedState.sections[section.section]) return;
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = cartNotification.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        cartNotification.classList.toggle('is-empty', parsedState.item_count === 0);
        document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);
        document.getElementById('cart-extra-products')?.classList.toggle('hide-extra-products', parsedState.item_count === 0);

        cartNotification.header?.reveal?.();
        cartNotification.open();
      })
      .catch(() => {
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items-notification').classList.add('cart__items--disabled');
    this.querySelectorAll('.loading-overlay')[line - 1].classList.remove('hidden');
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items-notification').classList.remove('cart__items--disabled');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);



document.addEventListener('DOMContentLoaded', function () {

  const cartBubble = document.getElementById('cart-icon-bubble');
  const cartNotification = document.querySelector('cart-notification');
  
  if (cartBubble && cartNotification) {
    cartBubble.addEventListener('click', function(event) {
      event.preventDefault();
  
      // Get the section IDs you need from the renderContents method
      const sectionIds = cartNotification.getSectionsToRender().map(section => section.id);
  
      // Build the section query string
      // NOTE: This assumes your section IDs match those used in your theme
      const params = new URLSearchParams();
      params.append('sections', sectionIds.join(','));
      params.append('sections_url', window.location.pathname);
  
      // Fetch rendered sections from Shopify
      fetch('/?' + params.toString())
        .then(res => res.json())
        .then(sections => {
          cartNotification.renderContents({ sections });
        });
    });
  }

  // --- Cart Upsell ---
  document.getElementById('cart-notification-upsells')?.addEventListener('click', async function (event) {
    const btn = event.target.closest('.add-upsell-to-cart');
    if (!btn) return;

    event.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Adding...';
    btn.classList.add('loading');

    const form = btn.closest('form.cart-upsell-form');
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = formData.get('quantity') || 1;

    try {
      // 1. Add to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `id=${encodeURIComponent(variantId)}&quantity=${encodeURIComponent(quantity)}`
      });
      if (!response.ok) throw new Error('Add to cart failed');

      // 2. Fetch the latest cart state to find the line index of the new item
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      // Find the line/index for the just-added variant
      let lineIndex = null;
      cart.items.forEach((item, i) => {
        if (item.variant_id == variantId) {
          // Shopify cart.js line indexes are 1-based
          lineIndex = i + 1;
        }
      });

      // 3. Call updateUpsellCartSections to re-render sections
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification && lineIndex !== null) {
        // Set to the quantity now in cart
        const cartItem = cart.items[lineIndex - 1];
        cartNotification.updateUpsellCartSections(lineIndex, cartItem.quantity, 'updates[]');
      } else if (cartNotification) {
        // Fallback: just update the first item (shouldn't happen)
        cartNotification.updateUpsellCartSections(1, cart.items[0].quantity, 'updates[]');
      }
    } catch (e) {
      alert('Sorry, could not add to cart. Please try again.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('loading');

      // requestAnimationFrame(() => {
      //   const parentCartElement = document.querySelector('.cart-notification');
      //   if (parentCartElement) parentCartElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // });

      setTimeout(() => {
        requestAnimationFrame(() => {
          const parentCartElement = document.querySelector('.cart-notification');
          if (parentCartElement) parentCartElement.scrollTo({ behavior: 'smooth', top: 0 })
        });
      }, 500);

    }
  });
});
